import { AnyAction } from 'redux';
import { put } from 'redux-saga/effects';
import { RECALCULATE_PRICE, REDUCER_SELECT_PRODUCT } from '../../../../';

export function* SelectFrameHeaderHandler(action: AnyAction) {
  yield put({ type: REDUCER_SELECT_PRODUCT, data: { product: action.data.product }});
  yield put({ type: RECALCULATE_PRICE });
}
